module.exports = __webpack_public_path__ + "9f350d502cfe8c1ca97699967509d140.png";